angular.module('core.auth', ['ngCookies']);



// WEBPACK FOOTER //
// ./src/app/core/auth/auth.module.js